var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundRigthBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    zoomAndPan: "magnify",
    viewBox: "0 0 224.87999 449.999984",
    height: 600,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a7dbbec0d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123 51 L 224.761719 51 L 224.761719 243 L 123 243 Z M 123 51 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3536f34047"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 340.925781 181.738281 L 197.140625 277.484375 L 86.808594 111.792969 L 230.59375 16.046875 Z M 340.925781 181.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdb7d4e720"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 269.035156 229.609375 C 308.738281 203.171875 316.285156 144.734375 285.886719 99.085938 C 255.488281 53.433594 198.660156 37.863281 158.957031 64.300781 C 119.25 90.742188 111.703125 149.179688 142.101562 194.828125 C 172.5 240.476562 229.328125 256.050781 269.035156 229.609375 Z M 269.035156 229.609375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7eed81998c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 340.925781 181.738281 L 197.140625 277.484375 L 87.183594 112.355469 L 230.96875 16.609375 Z M 340.925781 181.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74d5c8be56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 340.925781 181.742188 L 197.140625 277.488281 L 87.0625 112.179688 L 230.847656 16.433594 Z M 340.925781 181.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(-0.832347, 0.554255, -0.554255, -0.832347, 340.9275, 181.740728)",
    gradientUnits: "userSpaceOnUse",
    r: 263.221325,
    cx: 0,
    id: "10b311f79a",
    cy: 0,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.342041%, 19.160461%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.630432%, 19.085693%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 19.918823%, 19.010925%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 20.205688%, 18.936157%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 20.49408%, 18.861389%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 20.782471%, 18.786621%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.069336%, 18.711853%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.357727%, 18.635559%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.646118%, 18.560791%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 21.932983%, 18.486023%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 22.221375%, 18.411255%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 22.509766%, 18.336487%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 22.796631%, 18.261719%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.085022%, 18.185425%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.373413%, 18.110657%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.660278%, 18.035889%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 23.948669%, 17.961121%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.237061%, 17.886353%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.525452%, 17.811584%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 24.812317%, 17.736816%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.100708%, 17.660522%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.389099%, 17.585754%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.675964%, 17.510986%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 25.964355%, 17.436218%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.252747%, 17.36145%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.539612%, 17.286682%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 26.828003%, 17.210388%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.116394%, 17.13562%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.403259%, 17.060852%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.69165%, 16.986084%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 27.980042%, 16.911316%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 28.266907%, 16.836548%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 28.555298%, 16.76178%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 28.843689%, 16.685486%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.130554%, 16.610718%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.418945%, 16.53595%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.707336%, 16.461182%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 29.994202%, 16.386414%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 30.282593%, 16.311646%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 30.570984%, 16.235352%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 30.857849%, 16.160583%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.14624%, 16.085815%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.434631%, 16.011047%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 31.721497%, 15.936279%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.009888%, 15.861511%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.298279%, 15.786743%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.585144%, 15.710449%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 32.873535%, 15.635681%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 33.161926%, 15.560913%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 33.448792%, 15.486145%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 33.737183%, 15.411377%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.025574%, 15.336609%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.312439%, 15.261841%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.60083%, 15.185547%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 34.889221%, 15.110779%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 35.176086%, 15.036011%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 35.464478%, 14.961243%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 35.752869%, 14.886475%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.039734%, 14.811707%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.328125%, 14.735413%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.616516%, 14.660645%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 36.903381%, 14.585876%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 37.191772%, 14.511108%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 37.480164%, 14.43634%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 37.767029%, 14.361572%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.05542%, 14.286804%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.343811%, 14.21051%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.630676%, 14.135742%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.919067%, 14.060974%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.207458%, 13.986206%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.494324%, 13.911438%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 39.782715%, 13.83667%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.071106%, 13.760376%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.357971%, 13.685608%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.646362%, 13.61084%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 40.934753%, 13.536072%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.221619%, 13.461304%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.51001%, 13.386536%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 41.798401%, 13.311768%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.086792%, 13.235474%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.373657%, 13.160706%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.662048%, 13.085938%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 42.950439%, 13.011169%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 43.237305%, 12.936401%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 43.525696%, 12.861633%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 43.814087%, 12.785339%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.100952%, 12.710571%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.389343%, 12.635803%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.677734%, 12.561035%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 44.9646%, 12.486267%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 45.252991%, 12.411499%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 45.541382%, 12.336731%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 45.828247%, 12.260437%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.116638%, 12.185669%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.405029%, 12.110901%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.691895%, 12.036133%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 46.980286%, 11.961365%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 47.268677%, 11.886597%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 47.555542%, 11.811829%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 47.843933%, 11.735535%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.132324%, 11.660767%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.419189%, 11.585999%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.707581%, 11.51123%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 48.995972%, 11.436462%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.282837%, 11.361694%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.571228%, 11.2854%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 49.859619%, 11.210632%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 50.146484%, 11.135864%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 50.434875%, 11.061096%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 50.723267%, 10.986328%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.010132%, 10.91156%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.298523%, 10.836792%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.586914%, 10.760498%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 51.873779%, 10.68573%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 52.16217%, 10.610962%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 52.450562%, 10.536194%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 52.737427%, 10.461426%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.025818%, 10.386658%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.314209%, 10.310364%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.601074%, 10.235596%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 53.889465%, 10.160828%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.177856%, 10.08606%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.464722%, 10.011292%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 54.753113%, 9.936523%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.041504%, 9.861755%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.328369%, 9.785461%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.61676%, 9.710693%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 55.905151%, 9.635925%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 56.192017%, 9.561157%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 56.480408%, 9.486389%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 56.768799%, 9.411621%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.055664%, 9.336853%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.344055%, 9.260559%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.632446%, 9.185791%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.919312%, 9.111023%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.207703%, 9.036255%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.496094%, 8.961487%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.782959%, 8.886719%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.07135%, 8.810425%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.359741%, 8.735657%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.646606%, 8.660889%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.934998%, 8.586121%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.223389%, 8.511353%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.51178%, 8.436584%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.798645%, 8.361816%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.087036%, 8.285522%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.375427%, 8.210754%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.662292%, 8.135986%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.950684%, 8.061218%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.239075%, 7.98645%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.52594%, 7.911682%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.814331%, 7.835388%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.102722%, 7.76062%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.389587%, 7.685852%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.677979%, 7.611084%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.96637%, 7.536316%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.253235%, 7.461548%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.541626%, 7.38678%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.830017%, 7.310486%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.116882%, 7.235718%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.405273%, 7.16095%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.693665%, 7.086182%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.98053%, 7.011414%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.268921%, 6.936646%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.557312%, 6.860352%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.844177%, 6.785583%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.132568%, 6.710815%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.420959%, 6.636047%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.707825%, 6.561279%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.996216%, 6.486511%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.284607%, 6.411743%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.571472%, 6.335449%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.859863%, 6.260681%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.148254%, 6.185913%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.43512%, 6.111145%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.723511%, 6.036377%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.011902%, 5.961609%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.298767%, 5.886841%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.587158%, 5.810547%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.875549%, 5.735779%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.162415%, 5.661011%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.450806%, 5.586243%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.739197%, 5.511475%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.026062%, 5.436707%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.314453%, 5.360413%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.602844%, 5.285645%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.889709%, 5.210876%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.178101%, 5.136108%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.466492%, 5.06134%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.753357%, 4.986572%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.041748%, 4.911804%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.330139%, 4.83551%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.617004%, 4.760742%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.905396%, 4.685974%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.193787%, 4.611206%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.480652%, 4.536438%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.769043%, 4.46167%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.057434%, 4.385376%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.344299%, 4.310608%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.63269%, 4.23584%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.921082%, 4.161072%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.207947%, 4.086304%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.496338%, 4.011536%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.784729%, 3.936768%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.07312%, 3.860474%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.359985%, 3.785706%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.648376%, 3.710938%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.936768%, 3.636169%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.223633%, 3.561401%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.512024%, 3.486633%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.800415%, 3.410339%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.08728%, 3.335571%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.375671%, 3.260803%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.664062%, 3.186035%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.950928%, 3.111267%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.239319%, 3.036499%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.52771%, 2.961731%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.814575%, 2.885437%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.102966%, 2.810669%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.391357%, 2.735901%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.678223%, 2.661133%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.966614%, 2.586365%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.255005%, 2.511597%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.54187%, 2.436829%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.830261%, 2.360535%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.118652%, 2.285767%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.405518%, 2.210999%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.693909%, 2.13623%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.9823%, 2.061462%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.269165%, 1.986694%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.557556%, 1.9104%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.845947%, 1.835632%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.132812%, 1.760864%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.421204%, 1.686096%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.709595%, 1.611328%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.99646%, 1.53656%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.284851%, 1.461792%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.573242%, 1.385498%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.860107%, 1.31073%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 88.148499%, 1.235962%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 88.43689%, 1.161194%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 88.723755%, 1.086426%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 89.012146%, 1.011658%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 89.300537%, 0.935364%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 89.587402%, 0.860596%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 89.875793%, 0.785828%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 90.164185%, 0.71106%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 90.45105%, 0.636292%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 90.739441%, 0.561523%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 91.027832%, 0.486755%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 91.314697%, 0.410461%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 91.603088%, 0.335693%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 91.891479%, 0.260925%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 92.178345%, 0.186157%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 92.466736%, 0.111389%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 92.755127%, 0.0366211%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 92.89856%, 0%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "088fb36992"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.988281 272.90625 L 180.910156 272.90625 L 180.910156 352 L 36.988281 352 Z M 36.988281 272.90625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7dbbec0d9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3536f34047)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bdb7d4e720)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7eed81998c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74d5c8be56)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#10b311f79a)",
    d: "M 325.417969 189.023438 L 190.03125 -14.292969 L 11.046875 104.890625 L 146.433594 308.207031 Z M 325.417969 189.023438 ",
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#088fb36992)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7941d",
    d: "M 52.292969 349.84375 C 43.710938 349.84375 36.988281 340.871094 36.988281 329.417969 C 36.988281 317.96875 43.710938 308.996094 52.292969 308.996094 C 60.875 308.996094 67.597656 317.96875 67.597656 329.417969 C 67.597656 340.871094 60.875 349.84375 52.292969 349.84375 Z M 52.292969 316.652344 C 48.214844 316.652344 44.636719 322.617188 44.636719 329.417969 C 44.636719 336.222656 48.214844 342.1875 52.292969 342.1875 C 56.371094 342.1875 59.949219 336.222656 59.949219 329.417969 C 59.949219 322.617188 56.371094 316.652344 52.292969 316.652344 Z M 86.589844 321.535156 C 78.003906 321.535156 71.28125 310.863281 71.28125 297.238281 C 71.28125 283.617188 78.003906 272.945312 86.589844 272.945312 C 95.167969 272.945312 101.894531 283.617188 101.894531 297.238281 C 101.894531 310.863281 95.171875 321.535156 86.589844 321.535156 Z M 86.589844 280.601562 C 82.972656 280.601562 78.933594 287.714844 78.933594 297.238281 C 78.933594 306.765625 82.972656 313.878906 86.589844 313.878906 C 90.203125 313.878906 94.242188 306.765625 94.242188 297.238281 C 94.242188 287.714844 90.203125 280.601562 86.589844 280.601562 Z M 165.621094 351.273438 C 157.039062 351.273438 150.316406 342.300781 150.316406 330.851562 C 150.316406 319.398438 157.039062 310.425781 165.621094 310.425781 C 174.203125 310.425781 180.925781 319.398438 180.925781 330.851562 C 180.925781 342.300781 174.203125 351.273438 165.621094 351.273438 Z M 165.621094 318.082031 C 161.542969 318.082031 157.964844 324.046875 157.964844 330.851562 C 157.964844 337.652344 161.542969 343.617188 165.621094 343.617188 C 169.699219 343.617188 173.277344 337.652344 173.277344 330.851562 C 173.277344 324.046875 169.699219 318.082031 165.621094 318.082031 Z M 131.324219 322.964844 C 122.742188 322.964844 116.019531 312.292969 116.019531 298.671875 C 116.019531 285.046875 122.742188 274.375 131.324219 274.375 C 139.910156 274.375 146.632812 285.046875 146.632812 298.671875 C 146.632812 312.292969 139.910156 322.964844 131.324219 322.964844 Z M 131.324219 282.03125 C 127.710938 282.03125 123.667969 289.144531 123.667969 298.671875 C 123.667969 308.195312 127.710938 315.308594 131.324219 315.308594 C 134.941406 315.308594 138.980469 308.195312 138.980469 298.671875 C 138.980469 289.144531 134.941406 282.03125 131.324219 282.03125 Z M 131.324219 282.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 156.441406 363.246094 L 122.394531 329.171875 C 114.984375 321.757812 102.925781 321.757812 95.519531 329.171875 L 61.488281 363.230469 C 54.226562 370.410156 50.238281 380.402344 50.546875 390.648438 C 50.839844 400.554688 55.101562 409.824219 62.238281 416.085938 C 73.339844 425.824219 90.378906 427.296875 103.664062 419.664062 C 106.929688 417.792969 110.988281 417.792969 114.25 419.664062 C 119.929688 422.929688 126.296875 424.527344 132.59375 424.527344 C 141.019531 424.527344 149.320312 421.660156 155.675781 416.085938 C 162.8125 409.828125 167.074219 400.554688 167.371094 390.648438 C 167.675781 380.402344 163.6875 370.410156 156.441406 363.246094 Z M 91.523438 390.410156 C 91.464844 390.347656 91.398438 390.285156 91.332031 390.230469 C 89.0625 388.25 87.765625 385.480469 87.679688 382.425781 C 87.59375 379.484375 88.703125 376.667969 90.71875 374.695312 C 92.605469 372.847656 95.222656 371.808594 97.960938 371.808594 C 98.105469 371.808594 98.25 371.8125 98.394531 371.816406 C 101.398438 371.941406 104.125 373.238281 106.074219 375.476562 C 107.527344 377.148438 110.386719 377.148438 111.84375 375.476562 C 113.789062 373.238281 116.519531 371.9375 119.519531 371.816406 C 122.390625 371.714844 125.210938 372.75 127.199219 374.695312 C 129.210938 376.667969 130.320312 379.484375 130.234375 382.425781 C 130.148438 385.480469 128.851562 388.25 126.582031 390.230469 C 126.511719 390.285156 126.449219 390.347656 126.386719 390.410156 L 108.957031 407.855469 Z M 150.632812 410.328125 C 141.949219 417.941406 128.558594 419.050781 118.054688 413.027344 C 117.300781 412.59375 116.519531 412.230469 115.71875 411.910156 L 131.707031 395.90625 C 135.488281 392.5625 137.734375 387.738281 137.882812 382.648438 C 138.027344 377.574219 136.082031 372.683594 132.546875 369.222656 C 129.0625 365.8125 124.191406 363.992188 119.214844 364.167969 C 115.488281 364.320312 111.902344 365.601562 108.957031 367.785156 C 106.011719 365.601562 102.429688 364.320312 98.699219 364.167969 C 93.722656 363.988281 88.855469 365.8125 85.367188 369.222656 C 81.832031 372.683594 79.886719 377.574219 80.03125 382.644531 C 80.179688 387.738281 82.425781 392.5625 86.203125 395.90625 L 102.195312 411.910156 C 101.398438 412.226562 100.613281 412.59375 99.859375 413.027344 C 89.359375 419.050781 75.960938 417.945312 67.28125 410.328125 C 61.734375 405.464844 58.421875 398.210938 58.191406 390.421875 C 57.949219 382.292969 61.109375 374.367188 66.878906 368.660156 L 100.929688 334.585938 C 105.351562 330.15625 112.554688 330.15625 116.984375 334.585938 L 151.046875 368.675781 C 156.804688 374.367188 159.96875 382.292969 159.722656 390.421875 C 159.492188 398.210938 156.175781 405.46875 150.632812 410.328125 Z M 150.632812 410.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRigthBottom);
export default __webpack_public_path__ + "static/media/background_rigth_bottom.e04f53aa283ee9207c91bc35578f56a4.svg";
export { ForwardRef as ReactComponent };